import { MONTH_NAMES_NB } from "../../../../../../constants";
import addHours from "date-fns/addHours";
import differenceInHours from "date-fns/differenceInHours";
import getYear from "date-fns/getYear";
import isSaturday from "date-fns/isSaturday";
import isSunday from "date-fns/isSunday";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import _filter from "lodash/filter";
import _range from "lodash/range";
import moment from "moment";
import { HolidayData, Holiday } from "../../../../../../models";
import { getEarliestPossiblePortingDate } from "../../../../../../shared/util";

export const DATE_FORMAT_YYYY_MM_DD = "YYYY-MM-DD";

export const MONTHS = MONTH_NAMES_NB;

const generateHoursRange = (date: Date, startHour: number, closeHour: number): Date[] => {
    const hours: Date[] = [];

    _range(startHour, closeHour + 1, 1).forEach((hour) => {
        hours.push(setHours(setMinutes(new Date(date.getTime()), 0), hour));
        if (hour < closeHour) {
            hours.push(setHours(setMinutes(new Date(date.getTime()), 30), hour));
        }
    });

    return hours;
};

const calculateHourOffset = (startNumber: number, date: Date, startDate: Date) => {
    let offset = startNumber;
    const openingHour = setHours(date, startNumber);
    const dateDiff = differenceInHours(openingHour, startDate, { roundingMethod: "floor" });

    if (dateDiff < 0) {
        offset = startNumber + Math.abs(dateDiff);
    }

    return offset;
};

export const getHoursOpen = (date: Date, isEsim?: boolean) => {
    // Add an extra business hour if we're late enough in the hour that the order may spill into the next hour before completion
    const MIN_BUSINESS_HOURS_NEEDED = isEsim ? (new Date().getMinutes() >= 46 ? 6 : 5) : 26;
    const today = new Date();
    const startDate = isEsim ? getEarliestPossiblePortingDate(today) : addHours(today, MIN_BUSINESS_HOURS_NEEDED);
    const isWeekend = isSunday(date) || isSaturday(date);
    if (isWeekend) {
        return generateHoursRange(date, calculateHourOffset(8, date, startDate), 16);
    } else {
        return generateHoursRange(date, calculateHourOffset(8, date, startDate), 20);
    }
};

export const getHolidaysForGivenMonth = (currentDate: Date, holidayData: HolidayData) => {
    const yearIndex = getYear(currentDate);
    const holidays: Holiday[] = holidayData[yearIndex] || [];
    const dates = _filter(holidays, (holiday) =>
        moment(holiday.date, DATE_FORMAT_YYYY_MM_DD).isSame(currentDate, "month"),
    );
    return dates.map((d) => ({ date: moment(d.date, DATE_FORMAT_YYYY_MM_DD), name: d.localName }));
};
